import { render, staticRenderFns } from "./CustomFonts.vue?vue&type=template&id=343808f3"
import script from "./CustomFonts.vue?vue&type=script&lang=js"
export * from "./CustomFonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports